<h4 class="mb-5">Delete folder</h4>

<div>
	Documents<ng-container *ngFor="let folder of breadcrumbs">
		/ <span [innerHtml]="folder.title"></span
	></ng-container>
	<p class="mt-4">
		<em>All documents and folders inside this one will also be removed.</em>
	</p>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
		>Cancel</app-button
	>
	<app-button size="small" (click)="deleteFolder()">Delete</app-button>
</div>
